import React from "react";

type attributes = {
    bootStrapIconName : string,
    size:number,
    cssClasses :string;
}

export const BootstrapIcon = (props:attributes)=> {
    return <i className={props.cssClasses + " bi bi-"+props.bootStrapIconName} style={{fontSize:props.size+'px'}}/>
}
